var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChangePassword(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.75 1.75C12.3693 1.75 11.25 2.86929 11.25 4.25V9.25C12.6307 9.25 13.75 10.3693 13.75 11.75V18C13.75 19.3807 12.6307 20.5 11.25 20.5H3.75C2.36929 20.5 1.25 19.3807 1.25 18V11.75C1.25 10.3693 2.36929 9.25 3.75 9.25H10V4.25C10 2.17893 11.6789 0.5 13.75 0.5C15.8211 0.5 17.5 2.17893 17.5 4.25V9.25C17.5 9.59518 17.2202 9.875 16.875 9.875C16.5298 9.875 16.25 9.59518 16.25 9.25V4.25C16.25 2.86929 15.1307 1.75 13.75 1.75ZM3.75 10.5C3.05964 10.5 2.5 11.0596 2.5 11.75V18C2.5 18.6904 3.05964 19.25 3.75 19.25H11.25C11.9404 19.25 12.5 18.6904 12.5 18V11.75C12.5 11.0596 11.9404 10.5 11.25 10.5H3.75Z",
    fill: "#9B9B9B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChangePassword);
export default __webpack_public_path__ + "static/media/change-password.8e50276504a16e82e91bb9acb46cefbd.svg";
export { ForwardRef as ReactComponent };